import { Vue, Component } from 'vue-property-decorator'
import s from '~/utils/s'

@Component
export default class PharmacyDetailHeader extends Vue {
  render () {
    return (
      <h1 class="pharmacy-detail-header">
        {s(this.$store).pharmacyDetailPage.item?.nameForSite ? s(this.$store).pharmacyDetailPage.item?.nameForSite : s(this.$store).pharmacyDetailPage.item?.name}
      </h1>
    )
  }
}
